import http from "helpers/http.js";

// Use the main API URL (same as other services)
const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:44303/';

// Region scopes regional-tag resolution server-side (e.g. which games are
// best-sellers in the user's country). Caller should pass the same value
// that drives pricing locale — pricing.countryCode from Redux. Falls back
// to whatever the server treats as the default if omitted.
const regionParam = (region) =>
    region ? `?region=${encodeURIComponent(region)}` : '';

/**
 * Fetches all enabled games from the API
 * @param {string} [region] - ISO country code for tag scoping (US/AU/GB)
 * @returns {Promise<Array>} Array of game objects
 */
const getGames = async (region) => {
    try {
        const response = await http.get(`${API_URL}api/public/games${regionParam(region)}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching games:', error);
        throw error;
    }
};

/**
 * Fetches a single game by its gameId
 * @param {string} gameId - The game identifier (e.g., "catchphrase", "pointless")
 * @param {string} [region] - ISO country code for tag scoping (US/AU/GB)
 * @returns {Promise<Object>} Game object
 */
const getGameById = async (gameId, region) => {
    try {
        const response = await http.get(`${API_URL}api/public/games/${encodeURIComponent(gameId)}${regionParam(region)}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching game ${gameId}:`, error);
        throw error;
    }
};

/**
 * Fetches a single game by its store slug
 * @param {string} slug - The store slug (e.g., "catchphrase", "pointless")
 * @param {string} [region] - ISO country code for tag scoping (US/AU/GB)
 * @returns {Promise<Object>} Game object
 */
const getGameBySlug = async (slug, region) => {
    try {
        // Remove /shop/ prefix if present
        const cleanSlug = slug.replace(/^\/shop\//, '');
        const response = await http.get(`${API_URL}api/public/games/by-slug/${encodeURIComponent(cleanSlug)}${regionParam(region)}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching game by slug ${slug}:`, error);
        throw error;
    }
};

const gamesService = {
    getGames,
    getGameById,
    getGameBySlug
};

export default gamesService;
